module.exports = __webpack_public_path__ + "static/img/makephoto.6e94b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/makephoto.png
// module id = IgHx
// module chunks = 0